// claim.ts

import {
    MiniKit,
} from "@worldcoin/minikit-js";
import {
    SendTransactionError,
    type MiniAppSendTransactionErrorPayload,
    type SendTransactionResult,
} from "@worldcoin/minikit-js/commands";
import { encodeFunctionData } from "viem";

interface ClaimVoucherParams {
    address: string;
    abi: any;
    functionName: string;
    args: any[];
    value?: string;
    data?: string;
}

type ClaimResult =
    | (SendTransactionResult & { transaction_id?: string })
    | MiniAppSendTransactionErrorPayload;

function toClaimError(error: unknown): MiniAppSendTransactionErrorPayload {
    const errorCode =
        error instanceof SendTransactionError
            ? error.code
            : typeof error === "object" &&
                error !== null &&
                "error_code" in error &&
                typeof error.error_code === "string"
              ? error.error_code
              : "generic_error";

    const details =
        error instanceof SendTransactionError ? error.details : undefined;

    return {
        status: "error",
        error_code:
            errorCode as MiniAppSendTransactionErrorPayload["error_code"],
        version: 2,
        ...(details ? { details } : {}),
    };
}

export async function claim(
    params: ClaimVoucherParams[],
): Promise<ClaimResult> {
    try {
        const transactions = params.map(
            ({ address, abi, functionName, args, value, data }) => ({
                to: address,
                value,
                data:
                    data ??
                    encodeFunctionData({
                        abi,
                        functionName,
                        args,
                    }),
            }),
        );

        const { data } = await MiniKit.sendTransaction({
            chainId: 480,
            transactions,
        });
        console.log(data);
        return {
            ...data,
            transaction_id: data.userOpHash,
        };
    } catch (error) {
        const finalPayload = toClaimError(error);
        console.log(finalPayload, error);
        return finalPayload;
    }
}
